import { DetalleParametrosRegimenProyeccionHE } from "components/Admin/Horas Extras/Parametros Horas Extras/TypesParametrosHorasExtras";
import React, { Dispatch, SetStateAction, useState } from "react";

type ContextoParametrosMensualesHorasExtras = {
    consultandoParametrosAnio: boolean,
    setconsultandoParametrosAnio: Dispatch<SetStateAction<boolean>>,
    guardandoParametro:boolean,
    setguardandoParametro:Dispatch<SetStateAction<boolean>>,
    anioParametrosSeleccionado:number|null,
    setanioParametrosSeleccionado:  Dispatch<SetStateAction<number | null>>,
    creandoParametros:boolean,
    setcreandoParametros: Dispatch<SetStateAction<boolean>>,
    parametrosHorasRegimen:DetalleParametrosRegimenProyeccionHE[]|null,
    setparametrosHorasRegimen:Dispatch<SetStateAction<DetalleParametrosRegimenProyeccionHE[]|null>>,

}

const ParametrosMensualesHorasExtrasContext = React.createContext<ContextoParametrosMensualesHorasExtras | undefined>(undefined);


export function useParametrosMensualesHorasExtrasContext() {
    const contexto = React.useContext(ParametrosMensualesHorasExtrasContext);
    if (!contexto) {
        throw new Error('Para usar el hook asegurese de ser hijo del Proveedor ParametrosMensualesHorasExtrasContextProvider');
    }
    return contexto;
}


const ParametrosMensualesHorasExtrasContextProvider:React.FC = ({children}) => {
    const [consultandoParametrosAnio, setconsultandoParametrosAnio] = useState<boolean>(false);
    const [guardandoParametro, setguardandoParametro] = useState<boolean>(false);
    const [creandoParametros, setcreandoParametros] = useState<boolean>(false);

    const [anioParametrosSeleccionado, setanioParametrosSeleccionado] = useState<number|null>(null);
    const [parametrosHorasRegimen, setparametrosHorasRegimen] = useState<DetalleParametrosRegimenProyeccionHE[]|null>(null);





    const value:ContextoParametrosMensualesHorasExtras = {
        consultandoParametrosAnio,
        setconsultandoParametrosAnio,
        guardandoParametro,
        setguardandoParametro,
        anioParametrosSeleccionado,
        setanioParametrosSeleccionado,
        creandoParametros,
        setcreandoParametros,
        parametrosHorasRegimen,
        setparametrosHorasRegimen

    }
  
    return (
  
        <ParametrosMensualesHorasExtrasContext.Provider value={value}>
            {children}
        </ParametrosMensualesHorasExtrasContext.Provider>
    
    )
  }
  
  export default ParametrosMensualesHorasExtrasContextProvider;
